import React from 'react';

type HealthCheckTableProps = {
    records: any[];
    handleRowClick: (record: any, cell: string) => void;
    getColorForPercentage: (percentage: number | null) => string;
    getColorForStatus: (status: string | null) => string;
    getColorForStatusPort: (status: string | null) => string;
    getColorForAlerts: (alert: string | null) => string;
    renderLoadingOrData: (data: any, mainStatus: string) => any;
    formatDate: (dateString: string) => string;
};

const HealthCheckTable: React.FC<HealthCheckTableProps> = React.memo(
    ({
        records,
        handleRowClick,
        getColorForPercentage,
        getColorForStatus,
        getColorForStatusPort,
        getColorForAlerts,
        renderLoadingOrData,
        formatDate
    }) => {
        // Función para determinar si una celda está deshabilitada
        const isCellDisabled = (value: any) => {
            return value === null || value === '' || value === 'NO DATA';
        };

        return (
            <table className='w-full f-parrafo caption-bottom custom-table' id='table'>
                <thead >
                    <tr className='text-azul'>
                        <th className='table-cell'>Instance</th>
                        <th className='table-cell'>
                            Status
                            <span className="tooltip-icon" data-tooltip="UP: The instance is up and running. DOWN: The instance is down. NO DATA: No data is available.">
                                ?
                            </span>
                        </th>
                        <th className='table-cell'>CPU (%)</th>
                        <th className='table-cell'>RAM (%)</th>
                        <th className='table-cell'>Storage (%)</th>
                        <th className='table-cell'>Process Status</th>
                        <th className='table-cell'>Port Status</th>
                        <th className='table-cell'>Last Update</th>
                    </tr>
                </thead>
                <tbody>
                    {records.length === 0 ? (
                        <tr>
                            <td colSpan={8} className="text-center">
                                <span className='text-pink fw-bold fs-p'>No Data Available</span>
                            </td>
                        </tr>
                    ) : (
                        records.map((record, index) => (
                            <tr key={index} className='table-row'>
                                <td className='table-cell'>{record.instance}</td>
                                <td className='table-cell'>{record.mainStatus}</td>

                                <td
                                    className={`table-cell`}
                                    style={{ cursor: isCellDisabled(record.cpu) ? 'not-allowed' : 'pointer' }}
                                    onClick={() => !isCellDisabled(record.cpu) && handleRowClick(record, 'CPU')}
                                >
                                    {renderLoadingOrData(record.cpu, record.mainStatus)}
                                </td>

                                <td
                                    className={`table-cell`}
                                    style={{ cursor: isCellDisabled(record.ram) ? 'not-allowed' : 'pointer' }}
                                    onClick={() => !isCellDisabled(record.ram) && handleRowClick(record, 'RAM')}
                                >
                                    {renderLoadingOrData(record.ram, record.mainStatus)}
                                </td>

                                <td
                                    className={`table-cell`}
                                    style={{ cursor: isCellDisabled(record.storage) ? 'not-allowed' : 'pointer' }}
                                    onClick={() => !isCellDisabled(record.storage) && handleRowClick(record, 'Storage')}
                                >
                                    {renderLoadingOrData(record.storage, record.mainStatus)}
                                </td>

                                <td
                                    className={`table-cell`}
                                    style={{ cursor: isCellDisabled(record.processStatus) ? 'not-allowed' : 'pointer' }}
                                    onClick={() => !isCellDisabled(record.processStatus) && handleRowClick(record, 'Process Status')}
                                >
                                    {record.processStatus ? `${record.processStatus.active}/${record.processStatus.total}` : renderLoadingOrData(null, record.mainStatus)}
                                </td>

                                <td
                                    className={`table-cell`}
                                    style={{ cursor: isCellDisabled(record.portStatus) ? 'not-allowed' : 'pointer' }}
                                    onClick={() => !isCellDisabled(record.portStatus) && handleRowClick(record, 'Port Status')}
                                >
                                    {renderLoadingOrData(record.portStatus, record.mainStatus)}
                                </td>

                                <td className={`table-cell`}>
                                    {renderLoadingOrData(record.alerts ? formatDate(record.alerts) : '', record.mainStatus)}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        );
    }
);

export default HealthCheckTable;
